import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgFileUser = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M17.867 6.6 15.34 4.123a2.2 2.2 0 0 0-1.532-.622H7.667C6.47 3.5 5.5 4.451 5.5 5.625v12.75c0 1.173.97 2.125 2.167 2.125h8.666c1.192 0 2.167-.956 2.167-2.125V8.102c0-.561-.227-1.102-.633-1.501m-.992 11.775a.536.536 0 0 1-.542.531h-.054c-.26-1.507-1.588-2.656-3.196-2.656h-2.166c-1.61 0-2.937 1.15-3.196 2.656h-.054a.536.536 0 0 1-.541-.531L7.125 5.629c0-.293.243-.53.542-.53h5.416V7.75c0 .587.486 1.063 1.084 1.063h2.678v9.562zM12 10.938c-1.195 0-2.167.952-2.167 2.124 0 1.174.97 2.126 2.167 2.126s2.167-.952 2.167-2.126c0-1.172-.972-2.124-2.167-2.124"
    }));
export default SvgFileUser;
